/**
 * @generated SignedSource<<a91bc16fc2e48df14381ab04d0e94a85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Authenticated_user$data = {
  readonly dId: any | null;
  readonly email: string;
  readonly fullName: string | null;
  readonly isPanelist: boolean;
  readonly panelist: {
    readonly customPanelistPortal: {
      readonly hidePointsAndRedemption: boolean;
    } | null;
    readonly dId: any | null;
    readonly tenants: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly profile: {
    readonly id: string;
    readonly tenant: {
      readonly dId: any | null;
      readonly name: string;
      readonly vpmAccountId: number | null;
    };
  } | null;
  readonly profiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly tenant: {
          readonly name: string;
        };
      } | null;
    } | null>;
  };
  readonly vpmUserId: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"Authenticated_LDUser_user" | "PanelistLayout_user" | "StaffLayout_user">;
  readonly " $fragmentType": "Authenticated_user";
};
export type Authenticated_user$key = {
  readonly " $data"?: Authenticated_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Authenticated_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Authenticated_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmUserId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPanelist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNode",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TenantNode",
          "kind": "LinkedField",
          "name": "tenant",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vpmAccountId",
              "storageKey": null
            },
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNodeConnection",
      "kind": "LinkedField",
      "name": "profiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TenantNode",
                  "kind": "LinkedField",
                  "name": "tenant",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PanelistNode",
      "kind": "LinkedField",
      "name": "panelist",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TenantNodeConnection",
          "kind": "LinkedField",
          "name": "tenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TenantNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TenantNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomPortalNode",
          "kind": "LinkedField",
          "name": "customPanelistPortal",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hidePointsAndRedemption",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Authenticated_LDUser_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PanelistLayout_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StaffLayout_user"
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};
})();

(node as any).hash = "73e0104d72444255f0e21e2911af73cb";

export default node;
